// The All receipts table: one row per receipt, chips on one line, the row
// actions (Open, Send, Download) in a column pinned to the right edge so they
// stay in reach when the table scrolls sideways on a phone.
import { matchTag } from './matchTag';
import { cardText, payerName, paidByText } from './cardText';
import { usd, shortDate } from './money';

const CONFIRMED = new Set(['rcpt', 'loose', 'human']);

function ContextChip({ r }) {
  if (!r.context) return <span className="rc-tag rc-tag--wait">no context</span>;
  return CONFIRMED.has(r.tagSource) ? <span className="rc-tag">{r.context}</span> : <span className="rc-tag rc-tag--amber">{r.context}?</span>;
}

export default function ReceiptsTable({ rows, picked, onToggle, onToggleAll, sortBy, arrow, onOpen, onSend, onDownload, busy = false }) {
  const allOn = rows.length > 0 && rows.every((r) => picked.has(r.id));
  return (
    <div className="rc-scroll">
      <table className="rc-table rc-browse">
        <thead><tr>
          <th className="rc-col-pick"><input type="checkbox" aria-label="Select all shown" checked={allOn} onChange={(e) => onToggleAll(e.target.checked)} /></th>
          <th><button className="rc-sortbtn" onClick={() => sortBy('date')}>Date{arrow('date')}</button></th>
          <th><button className="rc-sortbtn" onClick={() => sortBy('merchant')}>Store{arrow('merchant')}</button></th>
          <th>Context</th><th>Paid by</th><th>Chase</th><th>Flags</th>
          <th className="num"><button className="rc-sortbtn" onClick={() => sortBy('amount')}>Total{arrow('amount')}</button></th>
          <th className="num rc-col-act"><span className="rc-visually-hidden">Actions</span></th>
        </tr></thead>
        <tbody>
          {rows.map((r) => {
            const m = matchTag({ match: { status: r.matchStatus, candidates: [] }, total: r.total }, r.linkedAmount !== null && r.linkedAmount !== undefined ? { amount: r.linkedAmount, how: r.linkedHow, impliedTip: null } : null, r);
            // "Not in Chase · Capital One Savor ·7502": the chip says why, the card sits under it.
            const nic = /^Not in Chase(?: · | )(.+)$/.exec(m.text);
            const [chip, why] = nic ? ['Not in Chase', nic[1]] : [m.text.replace(', to the penny', ''), null];
            const who = payerName(r);
            const card = cardText(r);
            const flags = [...(r.flags || []), ...(r.matchFlags || [])];
            return (
              <tr key={r.id}>
                <td className="rc-col-pick"><input type="checkbox" aria-label={`Select ${r.id}`} checked={picked.has(r.id)} onChange={() => onToggle(r.id)} /></td>
                <td className="rc-nowrap">{shortDate(r.purchaseDate)}</td>
                <td className="rc-store"><strong>{r.merchant || 'Merchant not read'}</strong><span className="rc-store-id">{r.id}</span>{(r.origFromName || r.origFrom) && <span className="rc-row-note rc-row-from">from {r.origFromName || r.origFrom}</span>}{r.note && <span className="rc-row-note" title={r.note}>{r.note}</span>}</td>
                <td className="rc-nowrap"><ContextChip r={r} />{r.owed ? <span className="rc-tag rc-tag--amber" style={{ marginLeft: 4 }}>owed</span> : null}</td>
                <td className="rc-stack2" title={paidByText(r)}>
                  <span className={r.cardKnown === false ? 'rc-unknown-card' : undefined}>{who || (r.cardKnown === false ? 'Unknown card' : card ? '' : '—')}</span>
                  {card && <span className="rc-sub2">{r.cardKnown === false ? `·${r.cardLast4}` : card}</span>}
                </td>
                <td className="rc-stack2" title={m.text}><span className={`rc-tag ${m.cls}`}>{chip}</span>{why && <span className="rc-sub2">{why}</span>}</td>
                <td className="rc-nowrap">{flags.length ? <span className="rc-flag" title={flags.join(', ')}>⚑ {flags.length}</span> : ''}{r.changedAfterSendAt ? <span className="rc-chip rc-chip--none">changed after send</span> : null}</td>
                <td className="num"><strong>{usd(r.total)}</strong></td>
                <td className="num rc-col-act">
                  <span className="rc-row-actions">
                    <button className="rc-anchor" onClick={() => onOpen(r.id)}>Open</button>
                    <button className="rc-btn rc-btn--small" disabled={busy} onClick={() => onSend([r.id])} aria-label={`Send ${r.id}`} title="Send"><span className="rc-act-icon" aria-hidden="true">✉</span><span className="rc-act-label">Send</span></button>
                    <button className="rc-btn rc-btn--small" disabled={busy} onClick={() => onDownload([r.id])} aria-label={`Download ${r.id}`} title="Download"><span className="rc-act-icon" aria-hidden="true">↓</span><span className="rc-act-label">Download</span></button>
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
